// Cookie consent management utilities

export const getCookieConsent = () => {
  try {
    const consent = localStorage.getItem('cookieConsent');
    return consent ? JSON.parse(consent) : null;
  } catch (error) {
    console.error('Error reading cookie consent:', error);
    return null;
  }
};

export const setCookieConsent = (preferences) => {
  try {
    const consentData = {
      ...preferences,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem('cookieConsent', JSON.stringify(consentData));
    return true;
  } catch (error) {
    console.error('Error saving cookie consent:', error);
    return false;
  }
};

export const hasConsentedTo = (cookieType) => {
  const consent = getCookieConsent();
  if (!consent) return false;
  return consent[cookieType] === true;
};

export const canShowAnalytics = () => {
  return hasConsentedTo('analytics');
};

export const canShowMarketing = () => {
  return hasConsentedTo('marketing');
};

export const canShowFunctional = () => {
  return hasConsentedTo('functional');
};

export const resetCookieConsent = () => {
  try {
    localStorage.removeItem('cookieConsent');
    return true;
  } catch (error) {
    console.error('Error resetting cookie consent:', error);
    return false;
  }
};

// Function to clear cookie consent for testing (remove in production)
export const clearCookieConsentForTesting = () => {
  try {
    localStorage.removeItem('cookieConsent');
    console.log('Cookie consent cleared for testing');
    return true;
  } catch (error) {
    console.error('Error clearing cookie consent:', error);
    return false;
  }
};

// Function to initialize analytics based on consent
export const initializeAnalytics = () => {
  if (canShowAnalytics()) {
    // Initialize Google Analytics or other analytics tools
    console.log('Analytics enabled - initializing tracking');
    // Add your analytics initialization code here
  }
};

// Function to initialize marketing tools based on consent
export const initializeMarketing = () => {
  if (canShowMarketing()) {
    // Initialize marketing tools like Facebook Pixel, Google Ads, etc.
    console.log('Marketing cookies enabled - initializing tracking');
    // Add your marketing tool initialization code here
  }
};

// Function to initialize functional features based on consent
export const initializeFunctional = () => {
  if (canShowFunctional()) {
    // Initialize functional features like personalization, preferences, etc.
    console.log('Functional cookies enabled - initializing features');
    // Add your functional feature initialization code here
  }
};
